import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Sidebar from "../partials/aside/Sidebar";
import TitleBar from "../partials/content/TitleBar";
import helperSpinner from "../../helpers/spinner";
import httpService from "../../services/httpServices/httpServices";
import parse from "html-react-parser";

function Welcome({ permissionsUser, role }) {
  const [notifications, setNotifications] = useState([]);

  const generateWelcomeTextForAdvertiser = () => {
    return (
      <div
        className="pt-4 border border-1 border-dark"
        id="welcome-advertiser-container"
      >
        <div className="px-3 pb-5 welcome-advertiser-header border-bottom border-dark">
          <div className="position-relative">
            <div className="position-absolute image-title-cover">
              <img
                className="img-fluid"
                src="/assets/img/red-highlight-cover-title.svg"
              ></img>
            </div>
            <div className="position-relative text-center">
              پیام ها و اعلانات هایلایت
            </div>
          </div>
          <div className="pt-4">
            <div className="pb-2">همراه گرامی سلام</div>
            <div className="pr-0 pr-lg-4 pb-5 text-justify">
              در این بخش پیام های سیستمی مدیریتی پلتفرم تبلیغات هایلایت نمایش
              داده می شود.
            </div>
          </div>
          <div className="pr-0 pr-lg-5">
            <ul className="list-unstyled">
              <li className="text-justify">
                <span>
                  <i className="fas fa-circle"></i>
                </span>
                <span className="pr-2">
                  تبلیغ دهنده عزیر لطفا قبل از شروع تبلیغات کسب و کار خود در
                  راهنمای گام به گام ویدیوهای آموزشی را نگاه کنید.
                </span>
              </li>
              <li className="pt-3 text-justify">
                <span>
                  <i className="fas fa-circle"></i>
                </span>
                <span className="pr-2">
                  تیم پشتیبانی هایلایت در هر زمان آماده پاسخگویی به شما هستند
                  لطفا جهت ارتباط از بخش پشتیبانی درخواست ثبت کنید.
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-4 px-3 welcome-items discount border-dark">
              <div className="position-relative pt-3">
                <div className="position-absolute image-title-cover">
                  <img
                    className="img-fluid"
                    src="/assets/img/green-highlight-cover-title.svg"
                  ></img>
                </div>
                <div
                  className="position-relative text-center"
                  style={{ zIndex: "9" }}
                >
                  {" "}
                  تخفیف ها و هدایای
                </div>
              </div>

              <div>
                <ul className="list-unstyled">
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2  ">
                      هدیه ثبت نام هایلایت مبلغ به مبلغ ۱۰۰ هزار تومان به موجودی
                      حساب شما اضافه گردید.
                    </span>
                  </li>
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2 ">
                      با شارژ حساب خود در هفته اول ثبت نام ۲۵٪ مبلغ شارژ اولیه
                      خود را هدیه بگیرید.
                    </span>
                  </li>
                  <li className="py-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      جهت خوش آمد گویی به جمع هایلایتی ها کد تخفیف ۱۰٪ HILITE
                      برای اولین کمپین تبلیغاتی شما.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-3 welcome-items solution-reduce-cost border-dark">
              <div className="position-relative pt-3">
                <div className="position-absolute image-title-cover">
                  <img
                    className="img-fluid"
                    src="/assets/img/green-highlight-cover-title.svg"
                  ></img>
                </div>
                <div
                  className="position-relative text-center"
                  style={{ zIndex: "9" }}
                >
                  راهکارهای کاهش هزینه{" "}
                </div>
              </div>

              <div>
                <ul className="list-unstyled">
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      در نظر داشته باشید تبلیغات سرمایه گذاریست نه هزینه , در
                      نتیجه هوشمندانه سرمایه گذاری کنید.
                    </span>
                  </li>
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      هنگام ساخت گروه نمایش دهنده , جایگاه های نمایش دهنده
                      تبلیغات را با دقت بررسی و انتخاب نمایید.
                    </span>
                  </li>
                  <li className="py-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      اگر دارای وب سایت هستید, می توانید به عنوان ناشر تبلیغات ,
                      درآمد کسب کنید یا هزینه تبلیغات رو کاهش دهید.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-3 welcome-items important-tips">
              <div className="position-relative pt-3">
                <div className="position-absolute image-title-cover">
                  <img
                    className="img-fluid"
                    src="/assets/img/green-highlight-cover-title.svg"
                  ></img>
                </div>
                <div
                  className="position-relative text-center"
                  style={{ zIndex: "9" }}
                >
                  نکات مهم و کارآمد
                </div>
              </div>

              <div>
                <ul className="list-unstyled">
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2 ">
                      تخفیف ها در زمان ایجاد کمپین تبلیغاتی قابل اعمال و استفاده
                      می باشد.
                    </span>
                  </li>
                  <li className="pt-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      گروه نمایش دهنده را هم قبل و هم در زمان ایجاد کمپین
                      تبلیغاتی می توانید ایجاد کنید.
                    </span>
                  </li>
                  <li className="py-4 text-justify d-flex">
                    <span>
                      <i className="fas fa-circle"></i>
                    </span>
                    <span className="pr-2">
                      در زمان ایجاد کمپین تبلیغاتی پیشنهاد می کنیم در گروه نمایش
                      دهنده خود حداقل ۲۰ جایگاه تبلیغات ۱۰ سایت برای حداقل ۱۵
                      روز انتخاب کنید.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const generateWelcomeTextForCustomer = () => {
    return (
      <p className="alert alert-success">
        <h1 className="text-dark"> همراه گرامی سلام</h1>
        <p className="text-justify text-dark pt-3">
          در این بخش پیام های سیستمی و مدیریتی پلتفرم تبلیغات آنلاین هایلایت
          نمایش داده می شود.
        </p>
        <p className="text-justify text-dark">
          همچنین آموزش های لازم و ضروری نیز در این بخش به شما عزیزان ارائه می
          گردد.
        </p>
        <p className="text-justify text-dark">
          تیم پشتیبانی هایلایت در هر زمان آماده پاسخگویی به شما هستند لطفا جهت
          ارتباط از بخش پشتیبانی درخواست ثبت کنید.
        </p>
        <p className="text-justify text-dark">با تشکر هایلایت</p>
      </p>
    );
  };
  const generateWelcomeTextForCoworker = () => {
    return (
      <p className="alert alert-success">
        <h1 className="text-dark">همکار و همراه گرامی سلام</h1>
        <p className="text-justify text-dark pt-3">
          در این بخش پیام های سیستمی و مدیریتی پلتفرم تبلیغات آنلاین هایلایت
          نمایش داده می شود.
        </p>
        <p className="text-justify text-dark">
          همچنین آموزش های لازم و ضروری نیز در این بخش به شما عزیزان ارائه می
          گردد.
        </p>
        <p className="text-justify text-dark">
          تیم پشتیبانی هایلایت در هر زمان آماده پاسخگویی به شما هستند لطفا جهت
          ارتباط از بخش پشتیبانی درخواست ثبت کنید.
        </p>
        <p className="text-justify text-dark">با تشکر هایلایت</p>
      </p>
    );
  };

  useEffect(() => {
    getNotifactionDashboard();
  }, []);

  const getNotifactionDashboard = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetNotifactionDashboard =
      await sendRequestGetNotifactionDashboard();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetNotifactionDashboard) {
      return;
    }

    setNotifications(resultSendRequestGetNotifactionDashboard);
  };

  const sendRequestGetNotifactionDashboard = async () => {
    const headersRequest = getHeaderForRequest();
    let notificationDashboard;
    try {
      notificationDashboard = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/notification-dashboard/latest-notification",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return notificationDashboard.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateWelcomeToUsersAreNotChecking = () => {
    return (
      <div className="alert alert-warning ">
        <i className="fa fa-exclamation-triangle pl-2 "></i>
        <p className="d-inline-block m-0">
          نقش شما هنوز تعیین نشده.برای تعیین نقش
          <Link
            style={{
              textDecoration: "none",
            }}
            className="text-primary d-inline-block px-2"
            to="/user/info"
          >
            اطلاعات کاربری
          </Link>
          خود را تکمیل نمایید.
        </p>
      </div>
    );
  };

  const generateNotifiactionDashboard = () => {
    return notifications.map((notification) => {
      const positionTexts = JSON.parse(notification.content);
      return (
        <div id="preview-notification-dashboard">
          <div>
            <div
              className="pt-4 border border-1 border-dark"
              id="welcome-advertiser-container"
            >
              <div className="px-3 welcome-advertiser-header border-bottom border-dark">
                <div className="position-relative">
                  <div className="position-absolute image-title-cover">
                    <img
                      className="img-fluid"
                      src="/assets/img/red-highlight-cover-title.svg"
                    />
                  </div>
                  <div className="position-relative text-center">
                    {parse(positionTexts.top.title)}
                  </div>
                </div>
                <div>{parse(positionTexts.top.text)}</div>
              </div>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-lg-4 px-3 welcome-items discount border-dark">
                    <div className="position-relative pt-3">
                      <div className="position-absolute image-title-cover">
                        <img
                          className="img-fluid"
                          src="/assets/img/green-highlight-cover-title.svg"
                        />
                      </div>
                      <div
                        className="position-relative text-center"
                        style={{ zIndex: 9 }}
                      >
                        {parse(positionTexts.right.title)}
                      </div>
                    </div>
                    <div className="px-2">
                      {parse(positionTexts.right.text)}
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 px-3 welcome-items solution-reduce-cost border-dark">
                    <div className="position-relative pt-3">
                      <div className="position-absolute image-title-cover">
                        <img
                          className="img-fluid"
                          src="/assets/img/green-highlight-cover-title.svg"
                        />
                      </div>
                      <div
                        className="position-relative text-center"
                        style={{ zIndex: 9 }}
                      >
                        {parse(positionTexts.middle.title)}
                      </div>
                    </div>
                    <div className="px-2">
                      {parse(positionTexts.middle.text)}
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 px-3 welcome-items important-tips">
                    <div className="position-relative pt-3">
                      <div className="position-absolute image-title-cover">
                        <img
                          className="img-fluid"
                          src="/assets/img/green-highlight-cover-title.svg"
                        />
                      </div>
                      <div
                        className="position-relative text-center"
                        style={{ zIndex: 9 }}
                      >
                        {parse(positionTexts.left.title)}
                      </div>
                    </div>
                    <div className="px-2">{parse(positionTexts.left.text)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      // return <p>{parse(notification.content)}</p>;
    });
  };

  const tag = "<p>aaavvv</p>";

  return (
    <>
      <Sidebar activeItem="welocome" />

      <div className="content-wrapper">
        <TitleBar title="میزکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {/* {parse(tag)} */}
              {permissionsUser.includes("permission-user-not-checking")
                ? generateWelcomeToUsersAreNotChecking()
                : generateNotifiactionDashboard()}
              <div>
                {/* {role == "تبلیغ دهنده" && generateWelcomeTextForAdvertiser()}
                {role == "همکار" && generateWelcomeTextForCoworker()}
                {role == "مشتریان همکار" && generateWelcomeTextForCustomer()} */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    permissionsUser: state.main.permissionsUser,
    role: state.main.role,
  };
};

export default connect(mapStateToProps, null)(Welcome);
